import { StateCreator } from 'zustand';
import { getCiamId } from '../../api/myaccount-cookie-api';
import { getStoreId, getVisitorId } from '../../utilities/visitor-cookie';
import { IAppState, IUserSlice } from './stateTypes';
import { getStoreSearchZipCode, getStoreZipCode } from '../../utilities/cookieHelper';

const createUserSlice: StateCreator<IAppState, [], [], IUserSlice> = (set) => ({
    visitorId: '',
    setVisitorId: () => {
        const visitorId = getVisitorId();
        if (visitorId) {
            set({ visitorId });
        }
    },
    ciamId: '',
    setCiam: async () => {
        const ciamId = await getCiamId();
        if (ciamId) {
            set({ ciamId });
        }
    },
    storeId: undefined,
    setStoreId: () => {
        const storeId = getStoreId();
        set({ storeId });
    },
    zipCode: undefined,
    setZipCode: () => {
        // Matches logic in header to use the zip code the customer entered, and only use the store search if we don't have one
        // header has full store info which means it has the actual store zip as a final fallback, but home microsite doesn't, so we left that off
        const enteredZipCode = getStoreSearchZipCode();
        const zipCode = getStoreZipCode();
        set({ zipCode: enteredZipCode || zipCode });
    },
});

export default createUserSlice;
